// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3k4Bq","insightsList":"newBusinessInsightsMenu_insightsList__1Qk6M","active":"newBusinessInsightsMenu_active__saL_-"};